import { getProviders, getSession } from "next-auth/react";
import SignInPage from "../../view/screens/SignIn/SignIn";

export interface ClientSafeProvider {
    id: string;
    name: string;
    type: "oauth" | "email" | "credentials";
    signinUrl: string;
    callbackUrl: string;
}

export interface SignInProps {
    providers: ClientSafeProvider[];
}

export default function SignIn({ providers }: SignInProps) {
    return <SignInPage providers={providers} />;
}

export async function getServerSideProps({ req, res }) {
    const providers = await getProviders();
    const session = await getSession({ req });

    if (session && res && session?.user?.id) {
        return {
            redirect: {
                destination: "/",
                permanent: false,
            },
        };
    }

    return {
        props: { providers },
    };
}
